exports = module.exports = require("../../../../node_modules/_css-loader@0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.vvc-tabbar {\n  position: relative;\n  box-sizing: border-box;\n  width: calc(100% - 200px);\n  height: 100%;\n  -webkit-user-select: none;\n  user-select: none;\n}\n.vvc-tabbar .vvc-tabbar-container {\n    position: absolute;\n    bottom: 0px;\n    box-sizing: border-box;\n    height: 30px;\n    padding: 0 10px;\n    white-space: nowrap;\n    transition: all .3s ease-in-out;\n}\n.vvc-tabbar .vvc-ctrl-btn {\n    position: absolute;\n    bottom: 0;\n    z-index: 1;\n    width: 10px;\n    height: 30px;\n    line-height: 30px;\n    color: #ccc;\n    cursor: pointer;\n}\n.vvc-tabbar .vvc-ctrl-btn.btn-left {\n      left: 0;\n}\n.vvc-tabbar .vvc-ctrl-btn.btn-right {\n      right: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.26.4@css-loader!./~/_vue-loader@10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-3ffde58d!./~/_sass-loader@6.0.6@sass-loader/lib/loader.js!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/tabbar/src/tabbar.vue
// module id = 460
// module chunks = 0